module.exports = __webpack_public_path__ + "static/RollingDoodle-0976e44fc5adb5e7522766a8d91a24a0.png";